<template lang="pug">
    .content(:class="{ 'has-text-centered': textAlignment === 'center' }")
        .column.is-offset-1.is-10
            component(v-if="subHeading" :is="subHeadingTag" :class="classes.subHeading") {{ subHeading }}
            component(v-if="heading" :is="headingTag" :class="classes.heading") {{ heading }}
</template>

<script>

// import _ from 'lodash'
import get from 'lodash.get'

export default {
    name: 'Heading',
    props: {
        section: {
            type: Object,
            required: true,
        },
        headingTag: {
            type: String,
            default: 'h2',
        },
        headingClass: {
            type: String,
            default: 'is-size-1-desktop is-size-2-tablet is-size-3-mobile has-text-weight-light',
        },
        subHeadingTag: {
            type: String,
            default: 'h3',
        },
        subHeadingClass: {
            type: String,
            default: 'is-size-5-desktop is-size-6-touch is-uppercase has-text-primary',
        },
    },
    computed: {
        heading() {
            return get(this.section, 'contents.0.title');
        },
        subHeading() {
            return get(this.section, 'contents.0.sub_title');
        },
        textAlignment() {
            let alignment = 'center'

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'text_alignment')
                if (setting && setting.value !== undefined) alignment = setting.value
            }

            return alignment
        },
        marginBottom() {
            let fr = 1
            let margin = 3 * fr

            if (this.section.settings && this.section.settings.length) {
                const config = this.section.settings.find(setting => setting.key === 'margin-bottom')
                if (config && config.value) {
                    switch (config.value) {
                        case 'small':
                            margin = 1 * fr
                            break;

                        case 'medium':
                            margin = 2 * fr
                            break;
                    }
                }
            }

            return margin
        },
        classes() {
            let classes = {
                heading: this.headingClass,
                subHeading: this.subHeadingClass,
            }

            const settings = get(this.section.contents[0], 'settings') || []
            const titleSize = settings.find(setting => setting.key === 'title_size')
            const subTitleSize = settings.find(setting => setting.key === 'sub_title_size')

            if (titleSize && titleSize.value !== undefined) {
                switch (titleSize.value) {
                    case 'large':
                        classes.heading = 'is-size-1-desktop is-size-2-tablet is-size-3-mobile has-text-weight-light'
                        break;

                    case 'small':
                        classes.heading = 'is-size-4-desktop is-size-5-tablet is-size-6-mobile has-text-weight-light'
                        break;

                    case 'regular':
                    default:
                        classes.heading = 'is-size-2-desktop is-size-3-tablet is-size-4-mobile has-text-weight-light'
                }
            }

            if (subTitleSize && subTitleSize.value !== undefined) {
                switch (subTitleSize.value) {
                    case 'large':
                        classes.subHeading = 'is-size-5-desktop is-size-6-touch is-uppercase has-text-primary'
                        break;

                    case 'small':
                        classes.subHeading = 'is-size-7-desktop is-size-7-touch is-uppercase has-text-primary'
                        break;

                    case 'regular':
                    default:
                        classes.subHeading = 'is-size-6-desktop is-size-7-touch is-uppercase has-text-primary'
                }
            }

            return classes
        }
    },
}
</script>

<style lang="sass" scoped>

    // @import "~bulma/sass/utilities/mixins"

    .content .column
        padding: 0
        *
            text-transform: initial
            margin: 0
            color: #80bb3d
            h3
                color: #000
    //     h2
    //         margin-top: 0
    //     h3
    //         font-weight: 900
    //         letter-spacing: 0

</style>
